export const ExpandRight = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer" clipPath="url(#clip0_9077_14677)">
        <path
          id="Vector"
          d="M5.94618 5.25521L7.81164 8.17187L5.94512 11.0885C5.88228 11.1866 5.84291 11.305 5.83154 11.4298C5.82018 11.5547 5.83728 11.681 5.88087 11.7943C5.92447 11.9075 5.99278 12.0031 6.07794 12.0699C6.16309 12.1367 6.26162 12.172 6.36215 12.1719L7.49533 12.1719C7.57521 12.1718 7.65407 12.1493 7.72607 12.106C7.79806 12.0628 7.86137 11.9998 7.91129 11.9219L10.0445 8.58854C10.1202 8.4703 10.1615 8.32334 10.1615 8.17187C10.1615 8.0204 10.1202 7.87345 10.0445 7.75521L7.91129 4.42187C7.86136 4.34392 7.79806 4.28098 7.72607 4.23771C7.65407 4.19443 7.57521 4.17194 7.49533 4.17187L6.36215 4.17187C6.26171 4.17195 6.16332 4.20749 6.07833 4.2744C5.99333 4.3413 5.92517 4.43685 5.88171 4.55005C5.83824 4.66325 5.82124 4.7895 5.83264 4.91425C5.84405 5.039 5.88341 5.15719 5.94618 5.25521Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9077_14677">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
